module.exports = __webpack_public_path__ + "img/email.8c93b0b0.svg";